import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
    Button
} from '@mui/material';

const DeleteConfirmDialog = ({ open, onClose, onConfirm, categoryName }) => {
    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle>Delete Category</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    All the contents inside this category will be deleted. Are you sure you want to delete the category: <strong>{categoryName}</strong>?
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Cancel</Button>
                <Button onClick={onConfirm} color="error">
                    Confirm
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default DeleteConfirmDialog;
